import React, { useEffect, useState } from "react";
import useSave from "../../Hooks/useSave";
import useFetch from "../../Hooks/useFetch";
import useDelete from "../../Hooks/useDelete";
import Table from "./../../Components/Table";
import { Link } from "react-router-dom";
import Modal from "react-awesome-modal";
import Api from "../../Hooks/Api";
const ProgressUpdates = (props) => {
  const [open, setOpen] = useState(false);
  const [inputs, setInputs] = useState({});
  const [view, setview] = useState(false);

  const [kpiOptions, setKpiOptions] = useState([]);
  const [update, setUpdate] = useState(false);
  const url = "api/progress";
  const { state, FetchAll } = useFetch(url);

  const fetchTarget = async () => {
    try {
      Api.get("/api/kpis")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setKpiOptions(data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };

  useEffect(() => {
    FetchAll();
    fetchTarget();
  }, []);

  const handleOpenModal = (event) => {
    event.persist();
    setInputs({});
    setOpen(true);
  };

  const handleInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };

  const handleEdit = () => {
    if (inputs.logId) {
      setOpen(true);
      setUpdate(true);
      setview(false);
    } else {
      alert("Select a record to edit");
    }
  };
  const handleView = () => {
    if (inputs.logId) {
      setview(true);
      setUpdate(false);
      setOpen(true);
    } else {
      alert("Select a record to veiw");
    }
  };
  const handleSelect = (k, event) => {
    setInputs({});
    setInputs(k);
  };
  const handleCloseModal = () => {
    setOpen(false);
    setview(false);
  };

  const HandleSubmit = (event) => {
    event.preventDefault();
    useSave(url, inputs);
  };
  const CallDeletehook = () => {
    useDelete(url + "/delete?id=" + inputs.logId);
  };
  const HandelDelete = () => {
    if (inputs.logId) {
      CallDeletehook();
    } else {
      alert("Select a record to delete");
    }
  };
  const ColumnData = [
    {
      label: "Id",
      field: "logId",
      sort: "asc",
    },
    {
      label: "Target",
      field: "target",
      sort: "asc",
    },
    {
      label: "Quarter",
      field: "quarter",
      sort: "asc",
    },
    {
      label: "Actual Value",
      field: "actualValue",
      sort: "asc",
    },
    {
      label: "Evidence Link",
      field: "evidenceLink",
      sort: "asc",
    },
    {
      label: "supervisor Comments",
      field: "supervisorComments",
      sort: "asc",
    },
    {
      label: "Submission Date",
      field: "submissionDate",
      sort: "asc",
    },
  ];
  let Rowdata1 = [];
  const rows = state.data;
  if (rows.length > 0) {
    rows.forEach((k) => {
      const Rowdata = {
        clickEvent: () => handleSelect(k),
        logId: k.logId,
        target: k.target.indicatorDescription,
        quarter: k.quarter,
        actualValue: k.actualValue,
        evidenceLink: k.evidenceLink,
        supervisorComments: k.supervisorComments,
        submissionDate: k.submissionDate,
      };
      Rowdata1.push(Rowdata);
    });
  }
  return (
    <div id="content" className="content">
      <ol class="breadcrumb float-xl-right">
        <li class="breadcrumb-item">
          {" "}
          <Link to="/">Home </Link>{" "}
        </li>
        <li class="breadcrumb-item active">Progress Update</li>
      </ol>
      <h1 class="page-header mb-3">Progress Update</h1>
      <div style={{ backgroundColor: "white" }}>
        <div className="row">
          <div class="col-sm-12 d-flex flex-row float-right">
            &nbsp; &nbsp; &nbsp;
            <button
              onClick={handleOpenModal}
              className="btn btn-primary p-2"
              style={{ marginRight: 5, marginTop: 5 }}
            >
              New
            </button>
            <button
              onClick={handleView}
              className="btn btn-success p-2"
              style={{ marginRight: 5, marginTop: 5 }}
            >
              View
            </button>
            <button
              onClick={handleEdit}
              className="btn btn-info p-2"
              style={{ marginRight: 5, marginTop: 5 }}
            >
              Edit
            </button>
            <button
              onClick={HandelDelete}
              className="btn btn-danger p-2"
              style={{ marginRight: 5, marginTop: 5 }}
            >
              Delete
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <Table Rows={Rowdata1} columns={ColumnData} />
          </div>
        </div>
      </div>

      <Modal visible={open} width="70%" height="70%" effect="fadeInUp">
        <div style={{ "overflow-y": "auto", height: "100%" }}>
          <a className="close" onClick={() => handleCloseModal()}>
            &times;
          </a>

          <div className="row">
            <div className="col-sm-5"></div>
            {view ? null : (
              <div className="col-sm-4 fontWeight-bold text-blue">
                Progress Update
              </div>
            )}
          </div>
          <div className="container-fluid">
            <div className="col-sm-12">
              <div className="ibox-content">
                <br />

                {view ? (
                  <div>
                    <h3>Progress Update</h3>
                    <table className="table table-sm">
                      <tbody>
                        <tr>
                          <td className="font-weight-bold">Target:</td>
                          <td>{inputs.target.indicatorDescription}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Quarter:</td>
                          <td>{inputs.quarter}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Actual Value:</td>
                          <td>{inputs.actualValue}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Evidence Link:</td>
                          <td>{inputs.evidenceLink}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">
                            Supervisor Comments:
                          </td>
                          <td>{inputs.supervisorComments}</td>
                        </tr>
                        <tr>
                          <td className="font-weight-bold">Submission Date:</td>
                          <td>{inputs.submissionDate}</td>
                        </tr>
                      </tbody>
                    </table>
                    <br />
                    <div className="row">
                      <div class="d-flex flex-row ">
                        <button
                          className="btn btn-primary p-2"
                          type="button"
                          onClick={handleEdit}
                        >
                          Update
                        </button>
                        &nbsp;
                        <button
                          onClick={HandelDelete}
                          className="btn btn-danger p-2"
                        >
                          Delete
                        </button>
                        &nbsp;
                        <button
                          className="btn btn-warning p-2"
                          type="button"
                          onClick={handleCloseModal}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                    <br />
                  </div>
                ) : (
                  <form className="form-horizontal" onSubmit={HandleSubmit}>
                    <div className=" row">
                      <div className="col-sm">
                        <div className="form-group">
                          <label
                            htmlFor="Datereceived"
                            className="fontWeight-bold"
                          >
                            Target
                          </label>
                          <select
                            className="form-control"
                            name="targetId"
                            required
                            value={inputs.targetId || ""}
                            onChange={handleInputChange}
                          >
                            <option value="">Select target</option>
                            {kpiOptions &&
                              kpiOptions.map((types) => (
                                <option
                                  key={types.targetId}
                                  value={types.targetId}
                                >
                                  {types.indicatorDescription}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className=" row">
                      <div className="col-sm">
                        <div className="form-group">
                          <label htmlFor="quarter" className="fontWeight-bold">
                            Quarter
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="quarter"
                            required
                            value={inputs.quarter}
                            onChange={handleInputChange}
                            // defaultvalue={inputs.name}
                          />
                        </div>
                      </div>
                      <div className="col-sm">
                        <div className="form-group">
                          <label
                            htmlFor="actualValue"
                            className="fontWeight-bold"
                          >
                            Actual Value
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="actualValue"
                            required
                            value={inputs.actualValue}
                            onChange={handleInputChange}
                            // defaultvalue={inputs.name}
                          />
                        </div>
                      </div>
                    </div>

                    <div className=" row">
                      <div className="col-sm">
                        <div className="form-group">
                          <label
                            htmlFor="evidenceLink"
                            className="fontWeight-bold"
                          >
                            Evidence Link
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="evidenceLink"
                            required
                            value={inputs.evidenceLink}
                            onChange={handleInputChange}
                            // defaultvalue={inputs.name}
                          />
                        </div>
                      </div>
                    </div>
                    <div className=" row">
                      <div className="col-sm">
                        <div className="form-group">
                          <label
                            htmlFor="Datereceived"
                            className="fontWeight-bold"
                          >
                            Supervisor Comments
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="supervisorComments"
                            required
                            value={inputs.supervisorComments}
                            onChange={handleInputChange}
                            // defaultvalue={inputs.name}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm">
                        <div className="row">
                          <div className="col-sm-12">
                            <div class="d-flex flex-row">
                              {update ? (
                                <button
                                  className="btn btn-primary p-2"
                                  type="submit"
                                >
                                  Update
                                </button>
                              ) : (
                                <button
                                  className="btn btn-primary p-2"
                                  type="submit"
                                >
                                  Submit
                                </button>
                              )}
                              &nbsp;
                              <button
                                className="btn btn-warning p-2"
                                type="button"
                                onClick={handleCloseModal}
                              >
                                Close
                              </button>
                            </div>
                            <br />
                          </div>
                        </div>
                        <br />
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default ProgressUpdates;
